// extracted by mini-css-extract-plugin
module.exports = {"sider":"sider-4e83656c","logo":"logo-0c355ce4","menu":"menu-ccead6a4"};